<template>
  <div class="team-review p-0">
    <!--    <pre class="text-white">-->
    <!--      {{team.data}}-->
    <!--    </pre>-->
    <div class="text-right pb-0 pt-0 chart-switch d-flex align-items-stretch justify-content-end">
      <select style="height:initial" class="mb-0 mr-2 w-auto form-control styled-input" v-model="graphField" name="" id="">
        <option value="average">{{$t('message.average')}}</option>
        <option value="median">{{$t('message.median')}}</option>
        <option value="standarddeviation">{{$t('message.stddev')}}</option>
        <option value="lowest">{{$t('message.lowest')}}</option>
        <option value="highest">{{$t('message.highest')}}</option>
      </select>
      <button @click.prevent="activeChart = 'current'" :class="activeChart === 'current' ? 'active' : ''"
              class="btn mr-1 btn-primary"><i class="fal fa-chart-pie"></i></button>
      <button @click.prevent="activeChart = 'evolution'"

              :class="activeChart === 'evolution' ? 'active' : ''"
              class="btn btn-primary"><i class="fal fa-chart-line"></i>
      </button>
    </div>

    <div class="current-team-scores row" v-show="activeChart === 'current'">
      <div class="col-md-8  mb-5">
        <generic-chart class="col-md-12"
                       @clickData="vitaminChartClickHandler"
                       v-if="vitaminLabels.length && vitaminData.length"
                       style="max-height:80vh;"
                       :style="isCompany ? 'min-height:50vh;' : ''"
                       :name="'Subscores'"
                       :legend="true"
                       :type="'polarArea'"
                       :set-labels="['Current','Previous']"
                       :chart-labels="vitaminLabels"
                       :chart-data="[vitaminData]">
        </generic-chart>
      </div>

      <div class="col-md-4 pt-4">
        <div class="row">
          <div v-if="team.Information"
               class="col-md-12 mb-5 info">
            {{team.Information}}
          </div>
          <!--          <div class="insights col-md-12 mb-5">-->
          <!--            <ul class="pl-0 mb-0">-->
          <!--              <li class="mb-3">-->
          <!--                <p class="mb-1">Insight 1</p>-->
          <!--                <span class="small">-->
          <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                                            Autem blanditiis pariatur quis repudiandae, veritatis voluptatum.-->
          <!--                                          </span>-->
          <!--              </li>-->
          <!--              <li class="mb-3">-->
          <!--                <p class="mb-1">Insight 2</p>-->
          <!--                <span class="small">-->
          <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                                            Adipisci atque cum cumque, id nostrum sint!-->
          <!--                                          </span>-->
          <!--              </li>-->
          <!--              <li class="mb-3">-->
          <!--                <p class="mb-1">Insight 3</p>-->
          <!--                <span class="small">-->
          <!--                                            Lorem ipsum dolor sit amet, consectetur adipisicing elit.-->
          <!--                                            Beatae itaque modi placeat sint temporibus vel?-->
          <!--                                          </span>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </div>-->
          <div v-if="!isCompany" class="col-md-6 mb-5">
            <div class="row">
              <div class="col-md-12">
                <div class="label-centered">{{ $t('message.team_score') }}</div>
              </div>
              <div class="col-md-12 mb-3">
                <div class="score score-medium score-medium-three"
                     :class="team ? ('score-c-'+truncate(team.vipscore,0)+' score-bc-'+truncate(team.vipscore,0)) : null">
                  <div :class="team ? (team.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                       class="content">
                    {{team ? truncate(team.vipscore,1) : '--'}}
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column col-md-12">
                <div class="med d-flex align-items-center mb-3">
                  <span class="flex-shrink-0 score mr-2" :class="'score-c-'+truncate(team.data.median,0)">{{truncate(team.data.median,1)}}</span>
                  <span class="">{{$t('message.median')}}</span>
                </div>
                <div class="stdev d-flex align-items-center">
                  <span class="flex-shrink-0 score mr-2 small"
                        :class="'score-c-'+truncate(7- team.data.standarddeviation,0)">{{truncate(team.data.standarddeviation,1)}}</span>
                  <span class="">{{$t('message.stddev')}}</span>
                </div>
              </div>
            </div>



          </div>
          <div :class="isCompany ? 'col-md-12' : 'col-md-6' " class=" mb-5">
            <div class="row">
              <div class="col-md-12">
                <div class="label-centered" :class="isCompany ? 'text-left' : ''">{{ $t('message.company_score') }}
                </div>
              </div>
              <div :class="isCompany ? 'col-auto' : 'col-md-12 mb-3'">
                <div class="score score-medium score-medium-three"
                     :class="company ? ('score-c-'+truncate(company.vipscore,0)+' score-bc-'+truncate(company.vipscore,0)) : null">
                  <div :class="company ? (company.vipscore % 1 > 0 ? 'small-score' : '') : ''"
                       class="content">{{company ? truncate(company.vipscore,1) : '--'}}
                  </div>
                </div>
              </div>
              <div class="d-flex flex-column" :class="isCompany ? 'col-md-6' : 'col-md-12'">
                <div class="med d-flex align-items-center mb-3">
                  <span class="flex-shrink-0 score mr-2" :class="'score-c-'+truncate(company.data.median,0)">{{truncate(company.data.median,1)}}</span>
                  <span class="">{{$t('message.median')}}</span>
                </div>
                <div class="stdev d-flex align-items-center">
                  <span class="flex-shrink-0 score mr-2 small"
                        :class="'score-c-'+truncate(7- company.data.standarddeviation,0)">{{truncate(company.data.standarddeviation,1)}}</span>
                  <span class="">{{$t('message.stddev')}}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="vitamin-information col-md-12 mb-5">
            {{ activeInfo }}
          </div>
        </div>
      </div>
      <div class="col-md-12">
        <all-vitamins ref="allvitamins"
                      class="p-0 mb-5"
                      :graph-field="graphField"
                      :vitamins="vitamins"
                      @clickVitamin="vitaminClickedHandler"
                      :scores="team.data.children"></all-vitamins>
      </div>
    </div>
    <div class="evolution-team-scores" v-show="activeChart === 'evolution'">
      <div class="row-flex flex-v align-items-baseline">
        <h2 class="w-auto mr-5">{{$t('message.evolution')}}</h2>
        <label :for="team.id+'-evolution-start'"
               class="mr-2">
          {{ $t('message.from') }}
        </label>
        <input
          v-model="evolutionStart"
          :name="team.id+'-evolution-start'"
          :id="team.id+'-evolution-start'"
          :max="today"
          min="2020-01-01"
          type="date"
          class="w-auto styled-input c_date_picker form-control">
        <label :for="team.id+'-evolution-end'"
               class="ml-2 mr-2">
          {{ $t('message.to') }}
        </label>
        <input
          v-model="evolutionEnd"
          :name="team.id+'-evolution-end'"
          :id="team.id+'-evolution-end'"
          :max="today"
          min="2020-01-01"
          type="date"
          class="w-auto styled-input c_date_picker form-control">
      </div>
      <evolution-chart :name="team.Title+'-evolution'"
                       v-if="vitaminLabels.length && teamHistories.length"
                       :dateLabels="evolutionDatesFormatted"
                       :entity="team"
                       :type="isCompany ? 'company' : 'team'"
                       :vitaminScores="vitaminScores"
                       :start="evolutionStart"
                       :end="evolutionEnd"
                       :setLabels="evolutionLabels"
                       :chartData="teamHistories">
      </evolution-chart>
    </div>


  </div>
</template>
<script>
  import AllVitamins from './AllVitamins'
  import GenericChart from '../Charts/GenericChart'
  import store from "../../store/store";
  import EvolutionChart from "../Charts/EvolutionChart"
  import moment from 'moment'

  export default {
    components: {
      AllVitamins,
      GenericChart,
      EvolutionChart
    },
    data() {
      return {
        activeVitaminIndex: 0,
        graphField:'average',
        evolutionStart: moment().format('YYYY-01-01'),
        evolutionEnd: moment().format('YYYY-MM-DD'),
        activeChart: 'current',
        company: store.getters.getCompany,
        vitamins: [],
        teamHistories: [],
        evolutionData: [],
        vitaminScores: {}
      }
    },
    methods: {
      vitaminClickedHandler(index){
        // console.log('clicked vitamin handler',index)
        this.activeVitaminIndex = index
      },
      vitaminChartClickHandler(evt) {
        const index = evt[0]._index;
        this.vitaminClickedHandler(index);
        this.$refs.allvitamins.setActiveVitamin(index)
      },
      getVitaminsArray(scoredata, correctDay = true) {
        let vitaminArray = [];
        scoredata.forEach((vitamin, vitaminIndex) => {
          let point = null;
          if (correctDay) {
            point = scoredata[vitaminIndex].average
          }
          vitaminArray.push(point)
        });

        return vitaminArray;
      },
      formatEvolutionData(teamAverages) {
        this.teamHistories = [];
        let vipScores = [];
        let vitaminScores = {};
        this.evolutionDates.forEach((date, dateIndex) => {
          // console.log('vitaminscores start date iteration',vitaminScores)
          let mDate = moment(date);
          let foundVip = null;
          let vitamins = [];
          teamAverages.forEach((teamAverage, averageIndex) => {
            vitamins = this.getVitaminsArray(teamAverage.data.children, false);
            let mAverageDate = moment(teamAverage.created_at);
            if (mAverageDate.isSame(mDate, 'day')) {
              foundVip = teamAverage.data.vipscore;
              // console.log('date match', teamAverage)
              vitamins = this.getVitaminsArray(teamAverage.data.children)
            }
          });
          vipScores.push(foundVip);
          vitamins.forEach((vitamin, ind) => {
            if (typeof vitaminScores[ind] === 'undefined') {
              vitaminScores[ind] = []
            }
            vitaminScores[ind].push(vitamin)
          });
          // console.log('vitamins for date', [date, vitamins])
          // console.log('vitaminscores end date iteration',vitaminScores)
        });
        // console.log('vitamin scores end', vitaminScores)
        this.teamHistories.push(vipScores);
        for (let key in vitaminScores) {
          this.teamHistories.push(vitaminScores[key]);
        }
      },
      async getEvolutionData() {
        const teamAveragesRequest = await this.axios.get(`/averages?type=team&team=${this.team.id}&created_at_gte=${this.evolutionStart}&created_at_lte=${this.computedEnd}&_sort=created_at:ASC`)
        this.evolutionData = teamAveragesRequest.data
      },
      async getVitamins() {
        const vitamins = await this.axios.get('/vitamines?published=1&_sort=sort:ASC');
        this.vitamins = vitamins.data;
        this.vitaminScores = {};
        this.vitamins.forEach(vitamin => {
          this.vitaminScores[vitamin.id] = vitamin
        })
      },

      async getEvolutionGraphData() {
        let type = 'team';
        const graphs = await this.axios.get('/graphs?type=' + type + '&_sort=updated_at:ASC');
        const graphData = graphs.data[0];

        //todo which graphs depends on type of review component (team, demographic, or company)
        //todo need array of data points per graph line
        let userVipData = [];
        let teamVipData = [];
        let companyGraphData = [];

        this.evolutionDates.forEach(date => {

        })
      },


    },
    created() {
      this.getVitamins();
      this.getEvolutionData();
    },
    watch: {
      evolutionStart() {
        this.getEvolutionData();
      },
      evolutionEnd() {
        this.getEvolutionData();
      },
      evolutionData() {
        // console.log('evolution data changed', this.evolutionData)
        this.formatEvolutionData(this.evolutionData)
      }
    },
    computed: {
      activeInfo() {
        let key = '';
        let ret = null
        let lang = store.getters.getLang;
        if (lang !== 'nl') {
          key = '_' + lang;
        }
        if(this.vitamins[this.activeVitaminIndex]){
          ret = this.vitamins[this.activeVitaminIndex]['Information' + key]
        }
        return ret
      },
      computedEnd() {
        // return moment(this.evolutionEnd).add(1, 'day').format('YYYY-MM-DD')
        return moment(this.evolutionEnd).add(1, 'day').format('YYYY-MM-DD')
      },
      evolutionLabels() {
        // let labels = [this.team.Title];
        let labels = [this.$t('message.score')];
        return labels.concat(this.vitaminLabels)
      },
      evolutionDatesFormatted() {
        return this.getDatesBetween(this.evolutionStart, this.evolutionEnd, 'DD/MM/YYYY');
      },
      evolutionDates() {
        return this.getDatesBetween(this.evolutionStart, this.evolutionEnd, 'YYYY-MM-DD');
      },
      vitaminData() {
        let data = [];
        let vitaminScores = this.team.data.children;
        // console.log('vitamindata', vitaminScores)
        if (vitaminScores) {
          vitaminScores.forEach(vitamin => {
            // console.log('vitamindata loop vitamins', vitamin)
            if (this.vitaminScores[vitamin.id]) {
              data.push(this.truncate(vitamin[this.graphField], 2))
            }
          });
        }

        return data
      },
      vitaminLabels() {
        const labels = [];
        if (this.vitamins) {
          this.vitamins.forEach(vitamin => {
            // console.log('vitamin', vitamin)
            labels.push(this.localizedField(vitamin,'Title'))
          });
        }
        // console.log('labels',labels)
        return labels
      },
    },
    props: {
      isCompany: {
        type: Boolean,
        default() {
          return false
        }
      },
      team: {
        type: Object
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Review/TeamReview.vue